import { toggleCustomerView } from 'actions/AgentHubActions'
import SwitchButton from 'LuxKit/Switch/SwitchButton'
import Tooltip from 'LuxKit/Tooltip'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const CustomerViewSwitchContainer = styled.div`
  display: inline-flex;
  flex-shrink: 0;
  width: max-content;
`

function AgentHubCustomerViewSwitch() {
  const intl = useIntl()
  const customerViewEnabled = useAppSelector(state => state.agentHub.customerView)
  const dispatch = useAppDispatch()

  const handleChange = useCallback(() => {
    dispatch(toggleCustomerView())
  }, [dispatch])

  return (<CustomerViewSwitchContainer>
    <Tooltip
      description={intl.formatMessage({
        id: '65X7f6j1UsW53E_7Vumh',
        defaultMessage: 'This will hide any commission when searching and viewing offers. Commission will show when purchasing any offer',
        description: 'Tooltip explaining what the customer view toggle does in agent hub',
      })}
    >
      <SwitchButton
        checked={customerViewEnabled}
        onChange={handleChange}
      >
        {intl.formatMessage({
          id: 'EutGB3mlM2GXnYXuUeJN',
          defaultMessage: 'Customer view',
          description: 'Label for the customer view toggle switch in agent hub',
        })}
      </SwitchButton>
    </Tooltip>
  </CustomerViewSwitchContainer>)
}

export default AgentHubCustomerViewSwitch
